import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'

import { stateComponentComplete } from '../../../models'
import { sendDataLayer } from '../../../helpers'

const ContentFive = () => {
    const location = useLocation()

    const [render, setRender] = useState<stateComponentComplete>({ ready: false})
    useEffect(() => {
        if (render.ready) sendDataLayer('onload-pager', location.pathname)
        setRender({ ready: true})
    }, [location.pathname, render.ready])
    return (
        <main className='container_content_five'>
            <section className='container_text_five'>
                <h1 className='title_five'>Este el momento de disfrutar lo que has construido con nosotros.</h1><br/><br/>
                <p className='text_five'>Profuturo te regala Soy+ porque tu esfuerzo no solo construye un futuro, también merece transformarse en experiencias hoy.</p>
            </section>
        </main>
    )
}

export default ContentFive